import {SYSTEM} from '../constants';

export const queryLoad = () => {
    return {
        type: SYSTEM.QUERY_LOAD
    }
}

export const queryGroup = (formData) => {
    return {
        type: SYSTEM.GROUP_QUERY,
        formData: formData
    }
}
export const querySingleGroup = (formData) => {
    return {
        type: SYSTEM.GROUP_QUERY,
        formData: formData
    }
}

export const querySuccess = (token, result) => {
	sessionStorage.setItem('token', token);
    return {
        type: SYSTEM.QUERY_SUCCESS,
        result: result
        
    }
}